import { ILandingOrigen } from "./types/LandingOrigen";

export const landing_config: ILandingOrigen[] = [{
    origen: "YPFRUTA",
    bgColor: "#0451E4",
    logo: "https://ypfenruta.ypf.com/logo-top-ypf.7a014d712bc16ea31a3b.svg",
    rutas: [
        "/seguros-corporativos-ART",
        "/seguros-corporativos-integral-comercio",
        "/seguros-corporativos-caucion",
        "/seguros-corporativos-flota",
        "/seguros-corporativos-transporte",
        "/seguros-corporativos-todo-riesgo-operativo",
        "/seguros-corporativos-AP"
    ],
    home_root: false,
    riegos: [
        {
            icon: "#icon-seg-flota",
            label: "Flota de Vehículos",
            link: "/seguros-corporativos-flota"
        },
        {
            icon: "#icon-seg-acc-personales",
            label: "Accidentes personales",
            link: "/seguros-corporativos-AP"
        },
        {
            icon: "#icon-seg-caucion",
            label: "Caución",
            link: "/seguros-corporativos-caucion"
        },
        {
            icon: "#icon-seg-art",
            label: "ART",
            link: "/seguros-corporativos-ART"
        },
        {
            icon: "#icon-seg-comercio",
            label: "Integral de Comercio",
            link: "/seguros-corporativos-integral-comercio"
        },
        {
            icon: "#icon-seg-transporte",
            label: "Transporte",
            link: "/seguros-corporativos-transporte"
        },
        {
            icon: "#icon-seg-tr-corp",
            label: "Todo Riesgo Operativo",
            link: "/seguros-corporativos-todo-riesgo-operativo"
        },
    ],
    riesgoData: [
        {
            id: "flotas_vehiculos",
            formulario: [
                {
                    name: "cantidadVehiculos",
                    label: "Cantidad de vehículos",
                    type: "number"
                }
            ]
        },
        {
            id: "caucion",
            formulario: [
                {
                    name: "tipoCobertura",
                    label: "Tipo de cobertura",
                    type: "select",
                    data: [
                        { value: 'separator', label: 'Aduaneras' },
                        { value: 'Aduaneras;Transito Terrestre', label: 'Tránsito terrestre' },
                        { value: 'Aduaneras;Importacion Temporal', label: 'Importación temporal' },
                        { value: 'Aduaneras;Falta de Documentacion', label: 'Falta de documentación' },
                        { value: 'Aduaneras;Diferencia de Derechos', label: 'Diferencia de derechos' },
                        { value: 'separator', label: 'Contractuales' },
                        { value: 'Contractuales;Ofertas', label: 'Ofertas' },
                        { value: 'Contractuales;Ejecucion de Contratos', label: 'Ejecución de contrato' },
                        { value: 'Contractuales;Anticipo', label: 'Anticipo' },
                        { value: 'Contractuales;Acopio', label: 'Acopio' },
                        { value: 'Contractuales;Fondo de Reparo', label: 'Fondo de reparo' },
                        { value: 'separator', label: 'Directores' },
                        { value: 'Directores;S.A.', label: 'S.A.' },
                        { value: 'Directores;SRL', label: 'SRL' },
                        { value: 'separator', label: 'Otros' },
                        { value: 'Otros;Alquiler', label: 'Alquiler' },
                        { value: 'Otros;Judicial', label: 'Judicial' },
                        { value: 'Otros;Turismo', label: 'Turismo' }
                    ]
                }
            ]
        },
        {
            id: "art",
            formulario: [
                {
                    name: "cantidadCapitas",
                    label: "Cantidad de cápitas",
                    type: "number"
                },
                {
                    name: "masaSalarial",
                    label: "Masa salarial",
                    type: "number"
                }
            ]
        },
        {
            id: "ap",
            formulario: [
                {
                    name: "cantidadAsegurados",
                    label: "Cantidad de asegurados",
                    type: "number"
                }
            ]
        },
        {
            id: "todo-riesgo-operativo",
            formulario: [
                {
                    name: "actividad",
                    label: "Actividad",
                    type: "text",
                }
            ]

        },
        {
            id: "integral-comercio",
            formulario: [
                {
                    name: "actividad",
                    label: "Actividad",
                    type: "text",
                },
                {
                    name: "superficieCubierta",
                    label: "Superficie cubierta",
                    type: "number",
                    labelGroup: "m2" 
                }
            ]
        }
    ],
    ready: true,
    noWpp: true
},
{
    origen: "SEGURARSE",
    bgColor: "",
    logo: "",
    rutas: [],
    riegos: [],
    riesgoData: [],
    ready: true, 
    home_root: true
}
]

